export default {
  sizes: ['16', '18', '20', '22', '24', '28'],
  colors: [
    'white',
    'black',
    'grey',
    'red',
    'green',
    'blue',
    'orange',
    'yellow',
    'silver',
    'gold',
    'brown',
    'purple',
    'pink',
  ],
  themes: [
    'Spring',
    'Summer',
    'Fall',
    'Winter',
    'Christmas ',
    'Easter',
    'Valentines day',
    '4th of July',
    'Halloween ',
    'Thanksgiving ',
    'Other',
  ],
};
